const servers = {
    dev: 'https://combater-dev.herokuapp.com',
    prod: 'https://combater-prod-actual.herokuapp.com',
    local: 'http://localhost:5000',
    mexus: 'https://tests.mexus.org'
}

export const URL = process.env.REACT_APP_URL || servers.prod
export const DEFAULT_AVATAR_URL = 'https://wpa-app.s3.eu-central-1.amazonaws.com/app/default-profile.jpeg'